import {Employees} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getEmployees(context, pagination) {
        return Employees.getEmployees(pagination).then((response) => {
            return response.data;
        });
    },
    getEmployee(context, id) {
        return Employees.get({id}).then((response) => {
            return response.data;
        });
    },
    createEmployee(context, item) {
        return Employees.create(item).then((response) => {
            return response.data;
        });
    },
    updateEmployee(context, item) {
        return Employees.update(item).then((response) => {
            return response.data;
        });
    },
    destroyEmployee(context, item) {
        return Employees.destroy(item).then((response) => {
            return response.data;
        });
    },
    getEmployeeField(context, item) {
        return Employees.getEmployeeField(item).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
